import { themeOptionFactories } from "./theme"
// Pages
import { PromotionDetailPage } from "./pages/promotions/[promotionId]"
import { EventDetailPage } from "./pages/events/[eventId]"
import { PageLayout } from "layouts/PageLayout"

export const standardExhibition = {
  themeOptionFactories,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [
      {
        path: "promotions/:promotionId",
        element: <PromotionDetailPage Layout={PageLayout} />,
      },
      {
        path: "events/:eventId",
        element: <EventDetailPage Layout={PageLayout} />,
      },
    ],
    "kiosk-v": [],
    "kiosk-h": [],
  },
}
